

import React, { useState, useEffect } from 'react'
import img from '../../../Assets/claimpro-design-home/image2.png'
import img2 from '../../../Assets/claimpro-design-home/6773c2b53c2141a6653b214d_about20image.webp.png'
import logo from '../../../Assets/home/logo.svg'
import vic from '../../../Assets/claimpro-design-home/Construction-Machine-JCB-Background-PNG-Image.png'
import img3 from '../../../Assets/claimpro-design-home/152223970420180328 3.png'
import vic3 from '../../../Assets/claimpro-design-home/mediumCrane.dd5ddd290d5430bda120 3.png'
import vic2 from '../../../Assets/claimpro-design-home/mediumRecoveryVan.4c4853cb8ac45f55b93e 2.png'
import vic4 from '../../../Assets/claimpro-design-home/images 3.png'
import vic5 from '../../../Assets/claimpro-design-home/BV-Acharya-56-removebg-preview.6310376e2f948c019163 1.png'
import vic6 from '../../../Assets/claimpro-design-home/full-length-portrait-of-an-auto-mechanic-pointing-to-a-hand-truck-with-car-tires-isolated-on-white-background-2AMH47C 1.png'
import './CustomerHome.css'
import axios from "../../../axiosInstance.js";
import CurrentOrdersList from '../VendorResponsesCustomer/CurrentOrdersList'
import { useNavigate } from 'react-router-dom'
import { IoLocationSharp } from 'react-icons/io5'
import BottomNavigationCustomer from './BottomNavigatonCustomer'
import PendingOrder from '../VendorResponsesCustomer/PendingOrder'



const defaultPosition = [19.2183, 72.9781];
function Home() {
    const navigate = useNavigate();
    const [address, setAddress] = useState('Fetching location...');
    const [city, setCity] = useState('');

  const[latitude, setLatitude] = useState(null);
   const [longitude , setLongitude] = useState(null);
   const userId = localStorage.getItem('userId')
  
       const fetchAddress = async (lat, lng) => {
      try {
  const res = await fetch(
    `https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat},${lng}&api_key=${process.env.REACT_APP_OLA_API_KEY}`
  );

  const data = await res.json();
  console.log('data?.fetched', data);

  const address = data?.results?.[0]?.formatted_address || 'Unknown address';
  setAddress(address);

  // Extract city
  const components = data?.results?.[0]?.address_components || [];
  const cityComponent = components.find(comp =>
    comp.types.includes('locality')
  );
  const city = cityComponent?.long_name || 'City';
  console.log(`City:`, city);
  setCity(city); // assuming you have a state for city
} catch (err) {
  console.error(`Failed to fetch address`, err);
}
    };
    
useEffect(() => {
        const keepKeys = [
       "iconify-version",
       "iconify-count",
      "token",
      "userId",
       "loginId",
       "loginTime",
       "userRole",
       "fromLogin",
      "justLoggedIn",
        "gps_location",
       "currentService"
    ];
       Object.keys(localStorage).forEach((key) => {
           if (!keepKeys.includes(key)) {
               localStorage.removeItem(key);
           }
       });
       sessionStorage.clear();
  const interval = setInterval(() => {
    const storedLocation = localStorage.getItem('gps_location');
    console.log('📍 Checking gps_location:', storedLocation);

    if (storedLocation) {
      try {
        const { lat, lng } = JSON.parse(storedLocation);

        // Check if both lat and lng are valid (not null, not 0)
        if (lat && lng) {
          setLatitude(lat);
          setLongitude(lng);
          console.log('✅ Real GPS location:', lat, lng);

          fetchAddress(lat, lng); // Only call once valid coords
          clearInterval(interval); // Stop checking once done
        } else {
          console.warn('⏳ GPS location not valid yet:', lat, lng);
        }
      } catch (err) {
        console.error('❌ Failed to parse GPS location:', err);
      }
    }
  }, 1000); // check every 1 second

  return () => clearInterval(interval); // cleanup
}, []);

  
useEffect(() => {
  const timer = setTimeout(() => {
    getCurrentLatLong(userId);
  }, 3000); 

  return () => clearTimeout(timer); // Cleanup if component unmounts or userId changes
}, [userId]); // Run this effect whenever userId changes

  
    const getCurrentLatLong = async (userId) => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getCurrentLatLong/${userId}`);
        const { lat, lng } = response.data.data;
  
        setLatitude(lat);
        setLongitude(lng);
  
        const newLoc = JSON.stringify({ lat, lng });
        localStorage.setItem('gps_location', newLoc);
      } catch (error) {
        console.error('❌ Failed to fetch current lat/lng:', error);
      }
    };
  

  return (
 <>
 <div className='body font-satoshi mb-[6rem]'>

      <div className="nav fixed top-0">
        <div  className="logo rounded-full">
            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/logo-compressed.png'/>
        </div>
        <div className="city">

            <div className="icon">
                 <i class="bi bi-geo-alt-fill"></i>
            </div>
            <div className="city-name">
                 {/* <IoLocationSharp className="text-gray-700 text-xl" /> */}
                    <h3>{city}</h3>
                    <p className="text-sm text-gray-700 leading-3 truncate max-w-[20vw] h-[1rem] mt-1">{address}</p>
            </div>
        </div>
    </div>
    <div className="home-banner">
        <div className="banner-div">
      <div className="banner-left">

              <h3>Get Quick Services</h3>
<p className="text-sm text-gray-700">For every service you opt for</p>

<button
 onClick={async () => {
                  navigate('/add-new-vehicle-driver');
                  localStorage.removeItem('formData')
                }}  
                className="px-4 py-1 font-bold bg-blue-500 text-white rounded">
  <i className="bi bi-lightning-fill mr-2"></i>
 <p className='text-sm'>Get Service</p> 

</button>
          </div>
<div className="banner-right">
<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/152223970420180328+3.png' alt=""/>
</div>
        </div>

    </div>
    <div className="service-heading">
        <p>Services</p>
        <h5 className='cursor-pointer' onClick={()=>{navigate('/all-services')}}>See All</h5>
    </div>
    <div className="service-cards">
<div
  onClick={async () => {
    navigate("/add-new-vehicle-driver");
    localStorage.removeItem("formData");
  }}
  className="service-card"
>
  <div className="service-card-img relative cursor-pointer"> {/* Make it relative */}
    <div className="absolute top-1 right-1 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-md shadow">
      Live
    </div>
    <img src={vic2} className="" alt="" />
  </div>
  <div className="service-card-text cursor-pointer">
    <p>Recovery Van</p>
  </div>
</div>

     <div
     onClick={async () => {
                  navigate('/add-new-vehicle-driver');
                  localStorage.removeItem('formData')
                }}   className="service-card cursor-pointer">
        <div className="service-card-img relative"> {/* Make it relative */}
    <div className="absolute top-1 right-1 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-md shadow">
      Live
    </div>
<img src={vic3} className='mt-[1rem]' alt=""/>


    </div>
    <div  className="service-card-text">
<p>Hydra Crane</p>
    </div>

    </div>

    
     <div 
     onClick={() => navigate('/general-inspection')}
     className="service-card cursor-pointer">
        <div className="service-card-img relative"> {/* Make it relative */}
  <div className="absolute top-1 right-1 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-md shadow">
      Live
    </div>
<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/images+3.png' className='mt-[1rem]' alt=""/>

    </div>
    <div className="service-card-text">
<p>Vehicle Inspection</p>
    </div>

    </div>
    
    <div className="service-card cursor-pointer">
  <div className="service-card-img relative">
    <div className="absolute top-1 right-1 bg-yellow-500 text-white text-[11px] font-semibold px-2 py-1 rounded-md shadow whitespace-nowrap max-w-fit">
      Coming S...
    </div>
    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/BV-Acharya-56-removebg-preview.6310376e2f948c019163+1.png' className='mt-[1rem]' alt="" />
  </div>
  <div className="service-card-text">
    <p>Advocate</p>
  </div>
</div>

     <div onClick={() => navigate('/customer/workshop-dashboard')}
     className="service-card cursor-pointer">
        <div className="service-card-img relative"> {/* Make it relative */}
  <div className="absolute top-1 right-1 bg-green-500 text-white text-[11px] font-semibold px-2 py-1 rounded-md shadow whitespace-nowrap max-w-fit">
      Live
    </div>
<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/images+3.png' className='mt-[1rem]' alt=""/>

    </div>
    <div className="service-card-text">
<p>Workshop</p>
    </div>

    </div>
      <div 
        className="service-card cursor-pointer">
        <div className="service-card-img relative"> {/* Make it relative */}
     <div className="absolute top-1 right-1 bg-yellow-500 text-white text-[11px] font-semibold px-2 py-1 rounded-md shadow whitespace-nowrap max-w-fit">
      Coming S...
    </div>
<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/full-length-portrait-of-an-auto-mechanic-pointing-to-a-hand-truck-with-car-tires-isolated-on-white-background-2AMH47C+1.png' className='mt-[1rem]' alt=""/>

    </div>
    <div className="service-card-text">
<p>Mechanic</p>
    </div>

    </div>
    </div>
        <div className="service-heading">
        <p>We Offer </p>
        <h5 className='cursor-pointer' onClick={()=>{navigate('/all-services')}}>See All</h5>
    </div>
    <div className="p-[1rem] flex gap-4 overflow-x-auto max-w-[95vw] scroll-smooth no-scrollbar mb-2 items-center cursor-pointer">
        <div>
        <div>

<div onClick={async () => {
                  navigate('/add-new-vehicle-driver');
                  localStorage.removeItem('formData')
                }}  
                className="WeOffer-card">

<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/mediumCrane.dd5ddd290d5430bda120+3.png' alt=""/>
<p>Crane Services</p>
    </div>
        </div>
        </div>

  <div>

<div onClick={async () => {
                  navigate('/add-new-vehicle-driver');
                  localStorage.removeItem('formData')
                }}  
                className="WeOffer-card">
<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/claimpro-design-home/mediumRecoveryVan.4c4853cb8ac45f55b93e+2.png' alt=""/>
<p>Recovery Van Services</p>
    </div>
        </div>

    </div>
<CurrentOrdersList/>
 </div>
  <BottomNavigationCustomer />

 </>
  )
}

export default Home;







// import React, { useEffect, useState } from 'react';
// import { FaSearch } from 'react-icons/fa';
// import { IoLocationSharp } from 'react-icons/io5';
// import { MdAccountCircle } from 'react-icons/md';
// import { FaMotorcycle } from 'react-icons/fa';
// import { Truck, Scale, Wrench, Hammer } from 'lucide-react';
// import { Link, useLocation, useNavigate, useNavigationType } from 'react-router-dom';
// import { ChevronDown, ChevronUp } from 'lucide-react';
// import img1profile from '../../../../../Assets/claimpro-design-home/profile/img1.png'
// const primaryColor = '#21a6e9';
// const defaultPosition = [19.2183, 72.9781];

// const CustomerHome = () => {
//   const navigate = useNavigate();
//   const [position, setPosition] = useState(null);
//   const [address, setAddress] = useState('Fetching location...');
//   // const prevRoute = usePreviousRoute();
//   const [showLogoutPrompt, setShowLogoutPrompt] = useState(false);
//   console.log('showLogoutPrompt', showLogoutPrompt)
//   const location = useLocation();
  
//   useEffect(() => {
//     const justLoggedIn = localStorage.getItem('justLoggedIn');
  
//     // Only push dummy state on first login
//     if (justLoggedIn === 'true') {
//       localStorage.removeItem('justLoggedIn');
//       window.history.pushState({ isCustomerHome: true }, '');
//     }
  
//     const handlePopState = (event) => {
//       // If back is pressed on customer home, show logout prompt
//       if (location.pathname === '/customer-home') {
//         setShowLogoutPrompt(true);
//         // Re-lock the page in history
//         window.history.pushState({ isCustomerHome: true }, '');
//       }
//     };
  
//     window.history.pushState({ isCustomerHome: true }, '');
//     window.addEventListener('popstate', handlePopState);
  
//     return () => window.removeEventListener('popstate', handlePopState);
//   }, [location]);
  

//   // useEffect(() => {
//   //   const handlePopState = () => {
//   //     const prevUrl = document.referrer;

//   //     // You could also check localStorage or custom state
//   //     if (location.pathname === '/customer-home') {
//   //       // Attempting to go back from this page — ask before logout
//   //       setShowLogoutPrompt(true);
//   //       window.history.pushState(null, '', location.pathname); // prevent actual back
//   //     }
//   //   };

//   //   window.addEventListener('popstate', handlePopState);
//   //   return () => window.removeEventListener('popstate', handlePopState);
//   // }, [location]);

//   // useEffect(() => {
//   //   const justLoggedIn = localStorage.getItem('justLoggedIn');
//   //   if (justLoggedIn === 'true') {
//   //     localStorage.removeItem('justLoggedIn');
//   //     window.history.pushState(null, '', location.pathname); // lock back button
//   //   }
  
//   //   const handlePopState = () => {
//   //     setShowLogoutPrompt(true);
//   //     window.history.pushState(null, '', location.pathname); // prevent further back
//   //   };
  
//   //   window.addEventListener('popstate', handlePopState);
//   //   return () => window.removeEventListener('popstate', handlePopState);
//   // }, []);
  

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate('/LoginPage', { replace: true });
//   };

//   useEffect(() => {
//     navigator.geolocation.getCurrentPosition(
//       async (pos) => {
//         const coords = [pos.coords.latitude, pos.coords.longitude];
//         setPosition(coords);
//         fetchAddress(coords);
//       },
//       () => {
//         setPosition(defaultPosition);
//         fetchAddress(defaultPosition);
//       }
//     );
//   }, []);

//   const fetchAddress = async ([lat, lon]) => {
//     try {
//       const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`);
//       const data = await res.json();
//       setAddress(data.display_name || 'Address not found');
//     } catch (error) {
//       setAddress('Failed to fetch address');
//     }
//   };

//   return (
//     <div className="font-sans min-h-screen bg-[#f5faff]">
//       {/* Header */}
//       <div className="p-4 bg-gradient-to-b from-[#8ccded] to-transparent shadow-sm">
//         <div className="flex items-center justify-between">
//           <div onClick={() => navigate('/SearchForLocation')} className="flex items-center space-x-2">
//             <IoLocationSharp className="text-[#16aaf0] text-xl" />
//             {/* <p className="text-sm text-gray-700 leading-3">Azad Nagar, Thane, Maharashtra, India</p> */}
//             <p className="text-sm text-gray-700 leading-3 truncate max-w-[60vw] h-[1rem]">{address}</p>
//             {/* <ChevronDown /> */}
//           </div>
//           {/* <Link to="/user-profile-details">
//             <MdAccountCircle className="text-4xl text-gray-700 hover:text-[#21Fa6e9] transition duration-200" />
//           </Link> */}
//           <Link to='/user-profile-details' className=' h-10 w-10 bg-white flex items-center justify-center rounded-full'>
//             <img src={img1profile} style={{ zIndex: "1001" }} className="text-lg font-medium" />
//           </Link>
//         </div>

//         {/* Search */}
//         <div className="mt-4 relative flex items-center bg-white rounded-md shadow-md">
//           <input
//             type="text"
//             placeholder="Search for services..."
//             style={{ marginTop: '0px', paddingLeft: '1rem' }}
//             className="pl-10 pr-10 py-2 w-full text-sm outline-none rounded-md"
//           />
//           <FaSearch className="absolute right-3 text-gray-400" />
//         </div>

//         {/* Banner */}
//         <div className="mt-5 p-4 rounded-2xl flex justify-between items-center bg-[#ade4ff] shadow-lg">
//           <div>
//             <p className="font-bold text-[#1a8dc2] text-lg">Get Quick Service</p>
//             <p className="text-sm text-gray-700">For every service you opt for</p>
//             <button
//              onClick={() => {
//                 navigate('/add-new-vehicle-driver');
//                 localStorage.removeItem('formData')
//               }}
              
//               className="mt-3 text-white bg-[#21a6e9] px-4 py-1.5 rounded-lg text-sm transition"
//             >
//               GET SERVICE
//             </button>
//           </div>
//           <img
//             src="https://media.istockphoto.com/id/1388141020/photo/truck-crane-lifts-a-load-at-a-construction-site.jpg?s=1024x1024&w=is&k=20&c=1v4TKyllOBUWNxLo23PDXMGXCyCZ7g8_aoMKNH129gs="
//             alt="Offer"
//             className="w-20 h-20 object-cover rounded-lg shadow-md"
//           />
//         </div>
//       </div>

//       {/* Services Grid */}
//       <div className="grid grid-cols-2 mb-[3rem] gap-4 p-4 md:grid-cols-3 lg:grid-cols-4">
//         <ServiceCard
//           icon={<Hammer size={42} className="text-[#21a6e9]" />}
//           title="Crane Service"
//           desc="QUICK & RELIABLE"
//           badge="LIVE NOW"
//         />
//         <ServiceCard
//           icon={<Truck size={42} className="text-[#21a6e9]" />}
//           title="Recovery Van"
//           desc="ARRIVES IN 10 MINS"
//           badge="QUICK"
//           subBadge="10 mins"
//         />
//         <ServiceCard
//           icon={<FaMotorcycle size={42} className="text-[#21a6e9]" />}
//           title="On Spot Repair"
//           desc="MECHANIC ON LOCATION"
//         />
//         <ServiceCard
//           icon={<Scale size={42} className="text-[#21a6e9]" />}
//           title="Advocate"
//           desc="LEGAL HELP"
//           badge="EXPERT"
//         />
//         <ServiceCard
//           icon={<Wrench size={42} className="text-[#21a6e9]" />}
//           title="Workshop"
//           desc="Nearby Garages"
//           badge="TOP RATED"
//         />
//       </div>

//       {/* Footer nav */}
//       <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-2 flex justify-around md:hidden shadow-md">
//         <FooterIcon label="Crane" icon={<Hammer className="text-[#21a6e9]" />} />
//         <FooterIcon label="Recovery" icon={<Truck className="text-[#21a6e9]" />} />
//         <FooterIcon label="Advocate" icon={<Scale className="text-[#21a6e9]" />} />
//         <FooterIcon label="Workshop" icon={<Wrench className="text-[#21a6e9]" />} />
//         <FooterIcon label="Repair" icon={<FaMotorcycle className="text-[#21a6e9]" />} />
//       </div>

//       {showLogoutPrompt && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-80">
//             <p className="text-lg font-semibold mb-4">Do you want to logout?</p>
//             <div className="flex justify-end gap-3">
//               <button
//                 onClick={() => setShowLogoutPrompt(false)}
//                 className="px-4 py-2 bg-gray-300 rounded"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleLogout}
//                 className="px-4 py-2 bg-red-500 text-white rounded"
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// const ServiceCard = ({ icon, title, desc, badge, subBadge }) => {
//   const navigate = useNavigate(); // <<< Add this

//   return (
//     <div onClick={() => navigate('/add-new-vehicle-driver')} className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition duration-200 transform hover:-translate-y-1">
//       <div className="mb-3">{icon}</div>
//       <h3 className="font-bold text-sm text-gray-800">{title}</h3>
//       <p className="text-xs text-gray-600">{desc}</p>

//       {badge && (
//         <p className="text-xs font-semibold text-orange-500 mt-1 uppercase tracking-wide">
//           {badge}
//         </p>
//       )}
//       {subBadge && (
//         <div className="text-[11px] mt-2 px-2 py-0.5 rounded-full bg-orange-100 text-orange-600 inline-block">
//           ⚡ {subBadge}
//         </div>
//       )}
//     </div>
//   );
// };

// const FooterIcon = ({ icon, label }) => (
//   // const navigate = useNavigate() // <<< Add this

//   <div className="flex flex-col items-center text-xs text-gray-600">
//     <div className="text-xl">{icon}</div>
//     <span>{label}</span>
//   </div>
// );

// export default CustomerHome;
